<template>
  <div class="ui-list__header" :class="headerClass">
    {{ name }}
  </div>
</template>

<script setup lang="ts">
type Props = {
  name: string
  headerClass?: string
}

defineProps<Props>()
</script>

<style>
.ui-list {
  &__header {
    @apply sticky top-0;
    @apply py-2 px-3;
    @apply bg-body;
    @apply border-b border-common-border;
    @apply text-light-text;
    @apply font-medium uppercase;
    @apply tracking-wider;
    @apply text-sm sm:text-xs;
  }
}
</style>
